module.exports = __webpack_public_path__ + "img/IOI_Square_White_Black.63656242.png";